module.exports = __webpack_public_path__ + "img/SpectroPicStandard.a9ad614a.png";